import React, { useState, useEffect } from "react";
import Main from "../pages/Main";
import { useNavigate } from "react-router-dom";
import { fetchAddmoneyTrancation } from "../api/addmoneyApi";
import { useNotify } from "../context/NotifyContext";
import { AppBreadcrumbs } from "../components/listing";

const AddmoneyReports = () => {
  const navigate = useNavigate();
  const { notify } = useNotify(); // ✅ Secure notify

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [transactions, setTransactions] = useState([]);
  const [totalTransactions, setTotalTransactions] = useState(0);

  const today = new Date().toISOString().split("T")[0];
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);

  const fetchTransactions = async () => {
    const params = {
      page,
      limit,
      search: searchQuery,
      startDate,
      endDate,
    };

    try {
      const result = await fetchAddmoneyTrancation(params);

      if (result?.success) {
        const response = result?.data;
        setTransactions(response?.ledgers || []);
        setTotalPages(response?.pagination?.totalPages || 1);
        setTotalTransactions(response?.pagination?.total || 0);
      } else {
        notify(result?.message || "Failed to fetch transactions", "error");
      }
    } catch (error) {
      console.error("Fetch transactions error:", error);
      notify("Something went wrong while fetching transactions", "error");
    }
  };

  useEffect(() => {
    fetchTransactions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit, startDate, endDate, searchQuery]);

  const gatewayList = [
    {
      id: 1,
      title: "PG — TERMINAL LOAD",
      img: "/razorpay_pg.png",
      label: "Add Money Reports",
    },
    {
      id: 2,
      title: "PG + PAYOUT REPORT",
      img: "/razorpay_pg.png",
      label: "PG + Payout Reports",
      path: "/pg-payout/history",
    },
  ];

  return (
    <Main showRightPanel={false}>
      <div className="mt-4 font-[Poppins]">
        <AppBreadcrumbs
          items={[
            { label: "Dashboard", to: "/" },
            { label: "MATM Module" },
            { label: "Add Money Reports" },
          ]}
        />

        <h2 className="text-[16px] font-semibold mb-4 mt-3 text-[var(--text-dark)]">
          LIST OF THE ADD MONEY REPORTS
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {gatewayList.map((item) => (
            <div
              key={item.id}
              className="ds-card !p-0 overflow-hidden"
            >
              <img src={item.img} alt="Gateway" className="w-full h-32 object-cover" />
              <div className="p-4 text-sm">
                <h3 className="font-semibold text-[14px] mb-3 line-clamp-2 text-[var(--text-dark)]">{item.title}</h3>
                <button
                  type="button"
                  onClick={() =>
                    navigate(
                      item.path
                        ? item.path
                        : `/matm-table?label=${encodeURIComponent(item.label)}`
                    )
                  }
                  className="ds-btn ds-btn-ghost w-full"
                >
                  VIEW REPORTS
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Main>
  );
};

export default AddmoneyReports;
